import { Typography } from "../../atoms/typography";
import { platformProps } from "../../lib";
import { useChatBubbleContext } from "./chat-bubble-context";
import { chatBubbleTimestampColor } from "./lib";
import type { ChatBubbleTimestampProps } from "./types";

export const ChatBubbleTimestamp = ({ children, className, testID }: ChatBubbleTimestampProps) => {
  const { variant } = useChatBubbleContext();

  return (
    <Typography
      variant="caption-sm"
      color={chatBubbleTimestampColor[variant]}
      align={variant === "system" ? "center" : undefined}
      className={className}
      {...platformProps({ testID, slot: "chat-bubble-timestamp" })}
    >
      {children}
    </Typography>
  );
};

ChatBubbleTimestamp.displayName = "ChatBubble.Timestamp";
